import { UTM_QUERY_PARAMS } from 'shared/presentation/constants';

type TUtmParam = (typeof UTM_QUERY_PARAMS)[number];

const FORMAT_UTM_PARAM: Record<TUtmParam, string> = {
  utm_campaign: 'campaign',
  utm_term: 'term',
  utm_source: 'source',
  utm_medium: 'medium',
  utm_content: 'content',
  ltk_gcm: 'ltk_gcm',
  ltk_gag: 'ltk_gag',
  ltk_gac: 'ltk_gac',
  ltk_gne: 'ltk_gne',
  gclid: 'googleId',
  fbclid: 'facebookId',
};

export default function getUtmsFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const utms: any = {};

  UTM_QUERY_PARAMS.forEach(param => {
    const value = params.get(param);
    if (value) utms[FORMAT_UTM_PARAM[param]] = value;
  });

  return utms;
}
